/**
 * @file The hover line for ONE cell of a derive-projected row, or `null` when the
 * projection fills nothing in that column. Consumer: `ArRow`, which asks once per
 * cell it renders on a projected row.
 * A projection can fill several sub-fields of the same composite column, so the
 * sentence names them together rather than choosing one — every column of an entry
 * reads the SAME source table, which is what lets one "Derived from …" sentence
 * carry all of them. Returning a sentence is the whole condition for showing it:
 * an undotted column locks the cell through `_calculated` and a dotted one locks
 * its sub-fields through `deriveSubFieldsByColumn`, so the line cannot be hung on
 * the marker without going silent on every composite sub-field.
 */

import { formDeriveCopy } from '@/services/formDerives';
import type { TypeId } from '#types';
import type { ArTableDeriveProjection } from './resolveArTableDeriveProjections';

function deriveCellTooltipOfColumn(
  projection: ArTableDeriveProjection,
  columnTypeId: TypeId,
): string | null {
  const filled = projection.columns.filter((column) => column.typeId === columnTypeId);
  if (filled.length === 0) return null;
  return formDeriveCopy.cellTooltip(
    projection.sourceTable,
    filled.map((column) => column.sourcePhrase).join(', '),
  );
}

export { deriveCellTooltipOfColumn };
